/**
 * @flow
 * @relayHash 85b1a0ce6a24bcb354870d736d6a6587
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type MergeVendors_Merge_MutationVariables = {|
  input: {
    toKeep?: ?string;
    toMerge?: ?string;
    name?: ?string;
    sabreCode?: ?string;
    contacts?: ?any;
    amenityPrograms?: ?$ReadOnlyArray<?string>;
    clientMutationId?: ?string;
  };
|};

export type MergeVendors_Merge_MutationResponse = {|
  +mergeVendors: ?{|
    +vendor: ?{|
      +name: string;
      +sabreCode: string;
      +contacts: ?any;
      +amenityPrograms: ?$ReadOnlyArray<?string>;
    |};
  |};
|};
*/


/*
mutation MergeVendors_Merge_Mutation(
  $input: MergeVendorsInput!
) {
  mergeVendors(input: $input) {
    vendor {
      name
      sabreCode
      contacts
      amenityPrograms
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "MergeVendorsInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MergeVendors_Merge_Mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "MergeVendorsInput!"
          }
        ],
        "concreteType": "MergeVendorsPayload",
        "name": "mergeVendors",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Vendor",
            "name": "vendor",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "sabreCode",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "contacts",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "amenityPrograms",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "MergeVendors_Merge_Mutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "MergeVendorsInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "MergeVendors_Merge_Mutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "MergeVendorsInput!"
          }
        ],
        "concreteType": "MergeVendorsPayload",
        "name": "mergeVendors",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Vendor",
            "name": "vendor",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "sabreCode",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "contacts",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "amenityPrograms",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation MergeVendors_Merge_Mutation(\n  $input: MergeVendorsInput!\n) {\n  mergeVendors(input: $input) {\n    vendor {\n      name\n      sabreCode\n      contacts\n      amenityPrograms\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// /src/components/Vendors/__generated__/MergeVendors_Merge_Mutation.graphql.js